import * as serializer from 'basic-editor-value-serializer';

import elementTypes from '../../../elements/types';
import HelptapEditor from '../../';
import * as baseNodeUtilities from '../base-node';

import {
  readFileAsText
} from 'utilities/file';

import {
  elementToNodes
} from './utilities';

export function getDefaultOptions() {

  const options = baseNodeUtilities.getDefaultOptions();

  return options;

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    ...options,
    type: elementTypes.HTML_IMPORTER
  };

  return node;

}

export function insert(editor, options) {

  const node = buildNode(options);

  HelptapEditor.insertNode(editor, node);

}

export function toggle(editor, options) {

  const nodeOptions = buildNode(options);

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export async function fromFile(file) {

  let fileContent = await readFileAsText(file);

  fileContent = fileContent.replaceAll('\n', '').replaceAll('\t', '').replaceAll('\r', '');

  return fromString(fileContent);

}

export function fromString(html) {

  const parsed = new DOMParser().parseFromString(html, 'text/html');

  return serializer.utilities.html.htmlToBlocks(window, serializer.utilities.node, parsed);

}